import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Collapse, Typography } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';
import Results from '../../Results';
import { useAuth } from '../../../context/AuthContext';

const { Text } = Typography;

/**
 * Renders an /api/search-shaped payload from the agent's present_projects tool.
 * The "Kostenschätzung öffnen" handoff passes {searchResults, filters} via
 * navigation state — the contract CostEstimation expects.
 */
const ProjectResultsBlock = ({ title, payload, filters }) => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  const handleOpenEstimation = () => {
    navigate('/estimate', {
      state: {
        searchResults: payload,
        filters,
        from: '/',
      },
    });
  };

  return (
    <div className="agent-projects-block">
      <div className="agent-projects-header">
        <Text strong>{title} ({payload.total_projects} Projekte)</Text>
        {hasPermission('kostenschaetzung') && (
          <Button
            type="primary"
            icon={<CalculatorOutlined />}
            onClick={handleOpenEstimation}
          >
            Kostenschätzung öffnen
          </Button>
        )}
      </div>
      <Collapse
        ghost
        items={[{
          key: 'results',
          label: 'Projektdetails und Kostenübersicht anzeigen',
          children: <Results results={payload} />,
        }]}
      />
    </div>
  );
};

export default ProjectResultsBlock;
